import { render, staticRenderFns } from "./ElementColorPicker.vue?vue&type=template&id=188f6945&scoped=true"
import script from "./ElementColorPicker.vue?vue&type=script&lang=js"
export * from "./ElementColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ElementColorPicker.vue?vue&type=style&index=0&id=188f6945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f6945",
  null
  
)

export default component.exports